<!-- Redefine Header -->
<app-redefine-header></app-redefine-header>

<!-- About Hero -->
<section class="about-hero">
    <div class="container">
        <span class="section-accent"></span>
        <h1>About this portal</h1>
        <p>Understanding how Redefine's parking solution works.</p>
    </div>
</section>

<!-- About Content -->
<section class="about-section">
    <div class="container">
        <div class="about-grid">
            <div class="about-content">
                <h2>A custom solution for Redefine</h2>
                <p>
                    This parking portal has been custom-built for Redefine Properties, providing a seamless experience 
                    for finding and securing parking bays across Redefine's premium property portfolio.
                </p>
                
                <h3>Powered by ParkUpp</h3>
                <p>
                    The technology behind this portal is provided by <a href="https://parkupp.co.za" target="_blank" rel="noopener">ParkUpp</a>, 
                    South Africa's leading parking management platform. ParkUpp's enterprise solution enables property 
                    companies like Redefine to offer branded parking services while benefiting from a proven, 
                    secure, and scalable platform.
                </p>
                
                <div class="feature-list">
                    <h3>Key features</h3>
                    <ul>
                        <li>
                            <i class="fa-solid fa-shield-halved"></i>
                            <div>
                                <strong>Secure authentication</strong>
                                <span>Single sign-on across all ParkUpp-powered portals with industry-standard security.</span>
                            </div>
                        </li>
                        <li>
                            <i class="fa-solid fa-credit-card"></i>
                            <div>
                                <strong>Unified payment methods</strong>
                                <span>Your saved payment methods work across all portals in the ParkUpp network.</span>
                            </div>
                        </li>
                        <li>
                            <i class="fa-solid fa-building"></i>
                            <div>
                                <strong>Premium properties</strong>
                                <span>Access to Redefine's curated portfolio of parking locations.</span>
                            </div>
                        </li>
                        <li>
                            <i class="fa-solid fa-headset"></i>
                            <div>
                                <strong>Dedicated support</strong>
                                <span>Direct support from both Redefine and the ParkUpp team.</span>
                            </div>
                        </li>
                    </ul>
                </div>
                
                <h3>Your account</h3>
                <p>
                    When you sign up or sign in to this portal, you're creating or using a ParkUpp account. 
                    This means you can also access other ParkUpp-powered parking portals with the same credentials. 
                    Your subscriptions on each portal are managed separately, but your profile and payment methods 
                    are shared for your convenience.
                </p>
                
                <div class="cta-box">
                    <h3>Questions?</h3>
                    <p>If you have any questions about how this portal works, please don't hesitate to get in touch.</p>
                    <div class="cta-actions">
                        <a routerLink="/contact" class="btn-secondary">Contact us</a>
                        <a (click)="viewAllProperties()" class="btn-outline">View properties</a>
                    </div>
                </div>
            </div>
            
            <div class="about-sidebar">
                <div class="sidebar-card">
                    <img src="/assets/whitelabel/redefine/logo.png" alt="Redefine Properties" class="brand-logo" />
                    <h4>Redefine Properties</h4>
                    <p>
                        One of South Africa's leading real estate investment trusts, actively managing a 
                        diversified property platform to deliver sustained value for all stakeholders.
                    </p>
                    <a href="https://www.redefine.co.za" target="_blank" rel="noopener" class="external-link">
                        Visit redefine.co.za
                        <i class="fa-solid fa-arrow-up-right-from-square"></i>
                    </a>
                </div>
                
                <div class="sidebar-card">
                    <img src="/assets/images/logos/logo-dark.svg" alt="ParkUpp" class="brand-logo parkupp-logo" />
                    <h4>ParkUpp</h4>
                    <p>
                        South Africa's leading parking technology platform, connecting drivers with 
                        parking spaces and empowering property owners with smart management tools.
                    </p>
                    <a href="https://parkupp.co.za" target="_blank" rel="noopener" class="external-link">
                        Visit parkupp.co.za
                        <i class="fa-solid fa-arrow-up-right-from-square"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Redefine Footer -->
<app-redefine-footer></app-redefine-footer>

